import client from './apiClient';
import {
  CreateSupportTicketCommentRequest,
  CreateSupportTicketRequest,
  SupportTicketComment,
  SupportTicketDetail,
  SupportTicketListResponse,
  SupportTicketStatusFilter,
  SupportTicket,
  SupportTicketUploadResponse,
} from '../models/supportTickets';

interface GetTicketsParams {
  status: SupportTicketStatusFilter;
  cursor?: string;
  limit?: number;
}

export const getSupportTickets = async ({
  status,
  cursor,
  limit = 50,
}: GetTicketsParams): Promise<SupportTicketListResponse> => {
  const { data } = await client.get<SupportTicketListResponse>('/support-tickets', {
    params: { status, cursor, limit },
  });
  return data;
};

export const getSupportTicketDetail = async (issueId: string): Promise<SupportTicketDetail> => {
  const { data } = await client.get<SupportTicketDetail>(`/support-tickets/${issueId}`);
  return data;
};

export const createSupportTicket = async (
  request: CreateSupportTicketRequest
): Promise<SupportTicket> => {
  const { data } = await client.post<SupportTicket>('/support-tickets', request);
  return data;
};

export const addSupportTicketComment = async (
  issueId: string,
  request: CreateSupportTicketCommentRequest
): Promise<SupportTicketComment> => {
  const { data } = await client.post<SupportTicketComment>(
    `/support-tickets/${issueId}/comments`,
    request
  );
  return data;
};

export const closeSupportTicket = async (issueId: string): Promise<void> => {
  await client.post(`/support-tickets/${issueId}/close`);
};

export const reopenSupportTicket = async (issueId: string): Promise<void> => {
  await client.post(`/support-tickets/${issueId}/reopen`);
};

export const uploadSupportTicketAttachment = async (
  file: File
): Promise<SupportTicketUploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await client.post<SupportTicketUploadResponse>(
    '/support-tickets/attachments',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
};
